module.exports = __webpack_public_path__ + "img/Play.f1582433.svg";